import axios from "axios";

const saveLandsMeta = async (metadata, sign) => {
  const baseApiUrl = process.env.REACT_APP_IMVERSED_API_URL;

  try {
    await axios({
      method: "post",
      url: `${baseApiUrl}/lands`,
      headers: {
        sign: sign,
      },
      data: metadata,
    });
  } catch (error) {
    console.log("lands/: " + error.response ? error.response : error.message);
  }
};

const getLandMeta = async (id) => {
  const baseApiUrl = process.env.REACT_APP_IMVERSED_API_URL;

  try {
    return await axios({
      method: "get",
      url: `${baseApiUrl}/lands/${id}`,
    });
  } catch (error) {
    console.log(`lands/${id}: ` + error.response ? error.response : error.message);
  }
};

const getLandsMeta = async (ids) => {
  const baseApiUrl = process.env.REACT_APP_IMVERSED_API_URL;

  try {
    return await axios({
      method: "get",
      url: `${baseApiUrl}/lands/by-ids`,
      params: {
        ids: ids,
      },
    });
  } catch (error) {
    console.log("lands/by-ids: " + error.response ? error.response : error.message);
  }
};

export { saveLandsMeta, getLandMeta, getLandsMeta };
